import { Base, Block, Button, useTranslation } from 'zf-web-components';
import { CONFIG } from 'config';
import styles from './style.module.less';
import type { ErrorProps } from './types';
import type { ReactElement } from 'react';

// TODO: 共通
export function Exception(props: ErrorProps): ReactElement | null {
  const [t] = useTranslation();
  if (props.error == null) {
    return null;
  }

  const message = props.error.formatted ?? props.error.message;
  return (
    <main className={styles.exception}>
      <Base.Row>
        <Base.Col span={6} offset={6}>
          <img className={styles.errorImg} src={`${CONFIG.IMAGE_STATIC}/thinking.svg`} />
        </Base.Col>
        <Base.Col className={styles.error} span={6}>
          <Block if={props.error.code != null}>
            <h1 className={styles.errorCode}>{props.error.code}</h1>
          </Block>
          <p className={styles.errorMessage}>{message}</p>
          <Base.Space>
            <Button type='primary'
              icon='RollbackOutlined'
              label={t('返回')}
              onClick={() => window.location.assign('/')} />
            <Button type='primary'
              icon='SwapOutlined'
              label={t('重试（刷新）')}
              onClick={() => window.location.reload()} />
          </Base.Space>
        </Base.Col>
      </Base.Row>
    </main>
  );
}
